import gql from 'graphql-tag';

const DISTRIBUTE_AUDIENCE_FROM_S3 = gql`
  query activateAudienceDevicesFromS3($audienceId: String!, $type: String!) {
    activateAudienceDevicesFromS3(audienceId: $audienceId, type: $type)
  }
`;

export default DISTRIBUTE_AUDIENCE_FROM_S3;
